import { Component, Input } from '@angular/core';
import { AlertLevel, AlertMessage } from 'src/app/core/Dtos/alert.entity';
import { MorayWestInstructionDTO } from 'src/app/core/Dtos/moray-west/instructions-dto';
import { AlertsService } from 'src/app/core/services/alerts.service';
import { DateFormatHelperService } from 'src/app/core/services/date-format-helper.service';
import { MorayWestService } from 'src/app/core/services/moray-west.service';
import { UserService } from 'src/app/core/user.service';

@Component({
  selector: 'app-moray-west-viewer',
  templateUrl: './moray-west-viewer.component.html',
  styleUrl: './moray-west-viewer.component.scss',
  standalone: false
})
export class MorayWestViewerComponent {
  @Input() public set InstructionId(instructionId: string | number) {
    if (instructionId !== 0)
      this.GetInstruction(instructionId);
    this._instructionId = instructionId;
  };
  public Instruction: MorayWestInstructionDTO = new MorayWestInstructionDTO();

  private _instructionId: string | number = '';

  constructor(
    private _morayWestService: MorayWestService,
     private _alertService: AlertsService,
    public DateFormatHelper: DateFormatHelperService,
    public UserService: UserService) {
  }



  GetInstruction(instructionId: string | number) {
    this._morayWestService.GetInstructionById(instructionId).subscribe(
      resp => {
        this.Instruction = resp;
      }
    )
  }
  
  ChangeStatus(status: string) {
    this._morayWestService.ChangeStatus(this._instructionId, status).subscribe(
      resp => {
        this.GetInstruction(this._instructionId);
      }
    )
  }

  ApplyToEDT() {
    this._morayWestService.ApplyToEDT(this._instructionId).subscribe({
      next: () => {
        this._alertService.ShowAlert(new AlertMessage(AlertLevel.Information, 'Instruction applied to EDT successfully.'));
        this.GetInstruction(this._instructionId);
      },
      error: () => {
        this._alertService.ShowAlert(new AlertMessage(AlertLevel.Error, 'Failed to apply instruction to EDT.'));
      }
    });
  }
}
